export default "__VITE_ASSET__MeeV5PLs__"